import VipManagement from '@/views/vipManagement/vipManagement.vue';
import MyInfoDetail from '@/views/Home/ktpMy/myInfoDetail.vue';
import MyAllSetting from '@/views/Home/ktpMy/myAllSetting.vue';
import infoModify from '@/views/Home/ktpMy/AllInfoModify.vue';
import accoundNumberInfo from '@/views/Home/ktpMy/accoundNumberInfo.vue';
import avatar from '@/views/Home/ktpMy/avatar.vue';
import { component } from 'vue/types/umd';

export default [
  {
    path: '/vipManagement',
    name: 'VIP会员',
    component: VipManagement
  },
  {
    path: '/myInfoDetail',
    name: 'myInfoDetail',
    component: MyInfoDetail
  },
  {
    path: '/myAllSetting',
    name: 'myAllSetting',
    component: MyAllSetting
  },
  {
    path: '/infoModify',
    name: 'infoModify',
    component: infoModify
  },
  {
    path: '/accoundNumberInfo',
    name: 'accoundNumberInfo',
    component: accoundNumberInfo
  },
  {
    path: '/avatar',
    name: '修改头像',
    component: avatar
  },
  {
    path: '/vipManagement/instruction',
    name: '超酷弹幕特效',
    component: () => import('@/views/vipManagement/instruction.vue')
  }
];
